import { useNode } from "@craftjs/core";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import CarouselSettings, { CarouselProps, Slide } from "../settings/CarouselSettings";
import useNormalizeDimentions from "../settings/DimentionSettings/useNormalizeDimentions";
import useNormalizeBorderRadius from "../settings/BorderRadius/useNormalizeBorderRadius";
import useNormalizeImageSettings from "../settings/ImageSettings/useNormalizeImageSettings";
import useResponsiveValues from "../hooks/useResponsiveValues";
import { DimentionProps } from "../settings/DimentionSettings/types";
import { BorderRadius as BorderRadiusProps } from "../settings/BorderRadius/BorderRadiusSettings";
import { ImageProps } from "../settings/ImageSettings/ImageSettings";
import { CssClass } from "../settings/ClassSettings";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

type Props = CarouselProps &
  DimentionProps &
  BorderRadiusProps &
  ImageProps &
  CssClass & {
    navigation?: boolean;
    pagination?: boolean;
    loop?: boolean;
  };

const initialSlides = [
  {
    id: "123",
    label: "Imagen 1",
    src: "/placeholder.png",
  },
  {
    id: "124",
    label: "Imagen 2",
    src: "/placeholder.png",
  },
];

const CarouselBlock = (props: Props) => {
  const responsive = useResponsiveValues();
  const dimentions = useNormalizeDimentions(props);
  const borderRadius = useNormalizeBorderRadius(props);
  const { ...imageProps } = useNormalizeImageSettings(props);

  const {
    id,
    connectors: { connect, drag },
  } = useNode();

  const slides = responsive.getValue(props?.slides, initialSlides);

  // Default to true for navigation and pagination if not provided
  const navigation = responsive.getValue(props.navigation);
  const pagination = responsive.getValue(props.pagination, true);
  const autoplay = responsive.getValue(props.autoplay);

  return (
    <div ref={(ref) => connect(drag(ref))} key={`${id}-${responsive.viewport}`}>
      <Swiper
        className={`carousel ${responsive.getValue(props.cssClass)}`}
        modules={[...(navigation ? [Navigation] : []), ...(pagination ? [Pagination] : []), ...(autoplay ? [Autoplay] : [])]}
        spaceBetween={0}
        slidesPerView={1}
        autoplay={autoplay}
        navigation={navigation}
        pagination={pagination ? { clickable: true } : false}
        loop={true}
        centeredSlides={true}
        freeMode={true}
      >
        {slides?.map((slide) => (
          <SwiperSlide key={slide.id}>
            <img
              style={{
                ...dimentions,
                ...borderRadius,
                ...imageProps,
              }}
              src={slide.src}
              alt={slide.label}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

CarouselBlock.craft = {
  displayName: "Carrusel",
  props: {
    dimentions: {
      width: "100",
      height: "unset",
      widthType: "%",
      heightType: "px",
    },
    navigation: true,
    pagination: true,
    autoplay: { delay: 3000, disableOnInteraction: false },
    // loop: true,
  },
  related: {
    settings: CarouselSettings,
  },
};

export default CarouselBlock;
